exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".WarningMsg {\r\n    /* max-width: 400px; */\r\n    /* margin-top: 10px; */\r\n    /* padding-top: 10px; */\r\n    /* padding-bottom: 10px; */\r\n    /* border: solid; */\r\n    /* border-width: thin; */\r\n    /* border-color: red; */\r\n    border-radius: 10px;\r\n    font-size: 10px;\r\n    font-family: inherit;\r\n    /* text-align: center; */\r\n    /* background-color: white; */\r\n}\r\n\r\n.WarningIcon {\r\n    /* float: left; */\r\n    font-family: inherit;\r\n}", ""]);

// exports
